'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privateKey = require('./privateKey');

var _privateKey2 = _interopRequireDefault(_privateKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EncryptionKeyPair = function () {
  function EncryptionKeyPair(opts) {
    var _this = this;

    _classCallCheck(this, EncryptionKeyPair);

    this.export = function (password) {
      return {
        privateKey: _this._privateKey.export(password),
        publicKey: _this._publicKey.export()
      };
    };

    // opts should contain either pemPrivateKey and password to load a key
    // or algo to generate a new one.
    this._privateKey = new _privateKey2.default(opts);
    this._publicKey = this._privateKey.publicKey();
  }

  _createClass(EncryptionKeyPair, [{
    key: 'private',
    get: function get() {
      return this._privateKey;
    }
  }, {
    key: 'public',
    get: function get() {
      return this._publicKey;
    }
  }]);

  return EncryptionKeyPair;
}();

exports.default = EncryptionKeyPair;